/* NILO V5.13.39 — tested catalogue core (pure helpers, browser + Node) */
(function(root,factory){
  var api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  if(root)root.NiloCatalogueCore=api;
})(typeof window!=='undefined'?window:(typeof globalThis!=='undefined'?globalThis:this),function(){
  'use strict';

  function norm(v){
    try{return String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[’']/g,"'").replace(/\s+/g,' ').trim();}
    catch(e){return String(v||'').toLowerCase().replace(/\s+/g,' ').trim();}
  }

  function familyKey(title){
    var s=norm(title)
      .replace(/\b(?:image|photo|img)[-_ ]?\d+\b/g,' ')
      .replace(/[^a-z0-9\u0600-\u06ff]+/g,'-')
      .replace(/^-+|-+$/g,'');
    return s||'unknown';
  }

  function familyFromDataset(value,title){
    var raw=String(value||'').trim();
    if(raw){raw=raw.split('|p:')[0];if(raw)return raw;}
    return familyKey(title);
  }

  function titleFlags(title){
    var t=norm(title);
    return {
      text:t,
      men:/\bhomme\b|\bmen\b|\bmale\b|رجالي|رجال/.test(t),
      women:/\bfemme\b|\bwoman\b|\bwomen\b|\bfemale\b|نسائي|نسائية/.test(t),
      boy:/garcon|garçon|\bboy\b|ولد/.test(t),
      girl:/\bfille\b|\bgirl\b|بنت/.test(t),
      caftan:/caftan|kaftan|قفطان/.test(t),
      takchita:/takchita|tekchita|تكشيط/.test(t),
      abaya:/abaya|عباي/.test(t),
      jellaba:/jellaba|djellaba|جلاب/.test(t),
      dress:(/\brobe\b|\bdress\b|فستان/.test(t)&&!/robe de nuit/.test(t)),
      sport:/survetement|survêtement|jogging|tracksuit|training|\bsport\b/.test(t),
      set:/\bensemble\b|\bset\b|طقم/.test(t),
      pyjama:/pyjama|pijama|pajama|homewear|sleepwear|robe de nuit|chemise de nuit|بيجام/.test(t),
      swim:/burkini|borkini|bourkini|بوركيني/.test(t),
      hijab:/hijab|khimar|foulard|voile|حجاب|خمار/.test(t),
      bag:/\bsac\b|\bbag\b|pochette|حقيب|شنط/.test(t),
      shoe:/chauss|\bshoe\b|sandale|botte|sneaker|basket|mocassin|talon|صندل/.test(t),
      accessory:/accessoire|bijou|ceinture|lunette|collier|bracelet|montre/.test(t),
      shirt:/chemise|\bshirt\b|قميص/.test(t),
      skirt:/\bjupe\b|\bskirt\b|تنور/.test(t)
    };
  }

  function explicitCategoryConflict(mode,flags){
    var target=mode==='pyjama_home'?'pyjama':mode==='sport_set'?'sport':mode;
    if(target==='set'&&flags.set&&!flags.sport)return false;
    if(flags[target])return false;
    var strong=['caftan','takchita','abaya','jellaba','dress','sport','pyjama','swim','hijab','bag','shoe','shirt','skirt'];
    for(var i=0;i<strong.length;i++)if(flags[strong[i]])return true;
    return false;
  }

  function matches(data,mode){
    data=data||{};mode=String(mode||'all').toLowerCase();
    if(data.available===false||String(data.available)==='0')return false;
    var p=Number(data.price||0),compare=Number(data.compare||0),tax=norm(data.taxonomy||''),flags=titleFlags(data.title||''),structured=/collection:|subcat:|type:/.test(tax);
    var has=function(re){return re.test(tax);};
    var tagMen=/genre:homme|collection:homme|cat:homme/.test(tax);
    var tagBoy=/genre:garcon|genre:garçon|collection:garcon|collection:garçon|subcat:garcon|subcat:garçon/.test(tax);
    var tagGirl=/genre:fille|collection:fille|subcat:fille/.test(tax);
    var tagKids=/genre:enfant|collection:enfant|cat:enfant/.test(tax)||tagBoy||tagGirl;
    var isMen=(tagMen||flags.men)&&!flags.women&&!flags.girl;
    var isBoy=(tagBoy||flags.boy)&&!flags.girl&&!flags.women;
    var isGirl=(tagGirl||flags.girl)&&!flags.boy&&!flags.men;
    var isKids=tagKids||isBoy||isGirl;
    if(mode==='men_set'||mode==='men_shirt'||mode==='men_shoe'||mode==='men_accessory'){
      return isMen&&matches(data,mode.slice(4));
    }

    switch(mode){
      case'all':return true;
      case'under140':return p>0&&p<14000;
      case'under160':return p>0&&p<16000;
      case'under180':return p>0&&p<18000;
      case'under200':return p>0&&p<20000;
      case'under250':return p>0&&p<25000;
      case'under300':return p>0&&p<30000;
      case'men_under250':return isMen&&p>0&&p<25000;
      case'men_under300':return isMen&&p>0&&p<30000;
      case'kids_under250':return isKids&&p>0&&p<25000;
      case'men':return isMen;
      case'boys':return isBoy;
      case'girls':return isGirl;
      case'kids':return isKids;
      case'women':return !isMen&&!isBoy&&!isGirl;
      case'new':return /business:nouveaute|business:nouveauté|(^|\|)nouveaute|(^|\|)nouveauté|\bnew\b/.test(tax);
      case'men_new':return isMen&&/business:nouveaute|business:nouveauté|(^|\|)nouveaute|(^|\|)nouveauté|\bnew\b/.test(tax);
      case'sale':case'flash':return compare>p||/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/.test(tax);
      case'men_sale':return isMen&&(compare>p||/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/.test(tax));
      case'kids_sale':return isKids&&(compare>p||/business:promotion|business:flash-ready|\bpromo\b|\bsale\b/.test(tax));
      case'bestseller':return /business:best-seller-potentiel|bestseller|best-seller|populaire/.test(tax);
      case'men_bestseller':return isMen&&/business:best-seller-potentiel|bestseller|best-seller|populaire/.test(tax);
      case'lowstock':return /derniere_piece|low_stock|stock_faible|faible/.test(tax);
      case'seasonal':return true;
    }

    var tests={
      caftan:/collection:caftans|subcat:caftans|type:caftan/,
      takchita:/collection:takchitas|subcat:takchitas|type:takchita/,
      abaya:/collection:abayas|subcat:abayas|type:abaya/,
      jellaba:/collection:jellabas|subcat:jellabas|type:jellaba/,
      dress:/collection:robes|subcat:robes|type:robe/,
      sport_set:/collection:survetements|collection:sportwear|type:ensemble-survetement|type:survetement/,
      set:/collection:ensembles|subcat:ensembles|type:ensemble/,
      pyjama_home:/collection:pyjamas|collection:homewear|collection:nuit|subcat:pyjamas|type:pyjama/,
      pyjama:/collection:pyjamas|collection:homewear|collection:nuit|subcat:pyjamas|type:pyjama/,
      swim:/collection:burkinis|subcat:burkinis|type:burkini/,
      hijab:/collection:hijabs|subcat:hijabs|type:hijab|type:khimar/,
      bag:/collection:sacs|subcat:sacs|type:sac/,
      shoe:/collection:chaussures|subcat:chaussures|type:chaussure|type:chaussures/,
      accessory:/collection:accessoires|subcat:accessoires|type:accessoire/,
      shirt:/collection:chemises|subcat:chemises|type:chemise/,
      skirt:/collection:jupes|subcat:jupes|type:jupe/
    };
    if(tests[mode]){
      if(explicitCategoryConflict(mode,flags))return false;
      if(mode==='set'&&flags.sport)return false;
      var titleMode=mode==='pyjama_home'?'pyjama':mode==='sport_set'?'sport':mode;
      var tagged=has(tests[mode]);
      return tagged||(!structured&&!!flags[titleMode]);
    }
    if(mode==='modest'){
      return flags.abaya||flags.jellaba||flags.caftan||flags.takchita||flags.hijab||/collection:abayas|type:abaya|collection:jellabas|type:jellaba|collection:caftans|type:caftan|collection:takchitas|type:takchita|collection:hijabs|type:hijab/.test(tax);
    }
    return true;
  }

  function distinct(items,getFamily,max,history,gap){
    items=(items||[]).slice();getFamily=getFamily||function(x){return familyKey(x&&x.title);};max=Number(max||items.length);gap=Number(gap||10);
    var out=[],recent=Array.isArray(history)?history.slice(-gap):[],seen={};
    for(var i=0;i<items.length&&out.length<max;i++){
      var item=items[i],f=String(getFamily(item)||'');
      if(!f||seen[f]||recent.indexOf(f)>=0)continue;
      seen[f]=1;out.push(item);recent.push(f);if(recent.length>gap)recent=recent.slice(-gap);
    }
    return out;
  }

  function spread(items,getFamily,history,targetGap,hardGap){
    var remaining=(items||[]).filter(Boolean).slice();
    getFamily=getFamily||function(x){return familyKey(x&&x.title);};
    targetGap=Math.max(1,Number(targetGap||10));hardGap=Math.max(1,Math.min(targetGap,Number(hardGap||8)));
    var hist=Array.isArray(history)?history.slice(-targetGap):[],out=[];
    function allowed(f,gap){var start=Math.max(0,hist.length-gap);for(var j=start;j<hist.length;j++)if(hist[j]===f)return false;return true;}
    while(remaining.length){
      var pick=-1,i,f;
      for(i=0;i<remaining.length;i++){f=String(getFamily(remaining[i])||'');if(allowed(f,targetGap)){pick=i;break;}}
      if(pick<0){for(i=0;i<remaining.length;i++){f=String(getFamily(remaining[i])||'');if(allowed(f,hardGap)){pick=i;break;}}}
      if(pick<0){
        /* No compliant option: keep all inventory, choose least-recent family. */
        var farthest=-1;
        for(i=0;i<remaining.length;i++){
          f=String(getFamily(remaining[i])||'');
          var distance=hist.lastIndexOf(f);
          if(distance<0){pick=i;break;}
          if(pick<0||distance<farthest){pick=i;farthest=distance;}
        }
      }
      var item=remaining.splice(pick,1)[0],fam=String(getFamily(item)||'');out.push(item);hist.push(fam);if(hist.length>targetGap)hist=hist.slice(-targetGap);
    }
    return out;
  }

  return{norm:norm,familyKey:familyKey,familyFromDataset:familyFromDataset,titleFlags:titleFlags,matches:matches,distinct:distinct,spread:spread};
});
